import { render, staticRenderFns } from "./BarDonought.vue?vue&type=template&id=d23211ee&"
import script from "./BarDonought.vue?vue&type=script&lang=js&"
export * from "./BarDonought.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports